import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import FlagIcon from 'vue-flag-icon';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import ImageUploader from 'vue-image-upload-resize';
import { i18n } from './plugins/i18n';

Vue.config.productionTip = false;

const bus = new Vue();
export default bus;

Vue.use(FlagIcon);
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
        libraries: 'places',
    },
});
Vue.use(ImageUploader);

new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');
